import React from 'react'
import {BsShieldFillCheck} from 'react-icons/bs';
import {BiSearchAlt} from 'react-icons/bi';
import {RiHeart2Fill} from 'react-icons/ri';

const Services = () => {
    const ServiceCard=({color,title,subTitle,icon})=>(
        <div className='flex flex-row justify-start items-center white-glassmorphism p-3 m-2 cursor-pointer hover:shadow-xl'>
            <div className={`w-10 h-10 rounded-full flex justify-center items-center ${color}`}>
            {icon}
            </div>
            <div className={`ml-5 flex flex-col flex-1`}>
            <h1 className='mt-2 text-white text-lg'>{title}</h1>
            <p className='mt-2 text-white text-sm ms:w-9/12'>{subTitle}</p>
            </div>
        </div>
    )
    return (
        <div className='flex flex-col md:flex-row w-full justify-center items-center gradient-bg-services'>
            <div className='flex mf:flex-row flex-column items-center justify-between md:p-20 py-12 px-4'>
                <div className='flex-1 flex flex-col justify-start items-start'>
                    <h1 className='text-white text-3xl sm:text-5xl py-2 text-gradient '>Services that we
                      <br /> continue to improve  </h1>
                </div>
            </div>
            <div className='flex-1 flex flex-col justify-start items-center mt-10'>
                <ServiceCard 
                    color='bg-[#2952E3]'
                    title='Security Gaurantee'
                    icon={<BsShieldFillCheck fontSize={21} className='text-white' />}
                    subTitle='Security is Gauranteed. We Always maintain privacy and quality of our product'
                />
                <ServiceCard 
                    color='bg-[#898458]'
                    title='Best Exchange Rates'
                    icon={<BiSearchAlt fontSize={21} className='text-white' />}
                    subTitle='Security is Gauranteed. We Always maintain privacy and quality of our product'
                />
                <ServiceCard 
                    color='bg-[#f84550]'
                    title='Fastest Transcactions'
                    icon={<RiHeart2Fill fontSize={21} className='text-white' />}
                    subTitle='Security is Gauranteed. We Always maintain privacy and quality of our product'
                />
            </div>
        </div>
    )
}

export default Services
